import { useEffect, useState } from 'react';

export const useDeviceWidth = (): boolean => {
  const [isMobVersion, setIsMobVersion] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobVersion(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobVersion;
};
